module.exports = __webpack_public_path__ + "static/media/game.e704941b.png";